import * as userTokenRequests from "../../api/userTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/carValues";
import {push} from "./message";


const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (carValues) => {
    return {type: FINISH_LOAD, payload: carValues};
};

export const getCarValues = () => {
    return dispatch => {
        dispatch(startLoading());
        userTokenRequests.getCarValues()
            .then(carValues => {
                dispatch(finishLoading(carValues))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};